import { apolloClient } from "@/src/lib/apollo-client";
import {
  GetCompanyDocument,
  GetCompanyQuery,
  GetContactsDocument,
  GetContactsQuery,
  Companies,
  Contacts,
} from "@/src/gql/graphql";

export async function fetchCompanyById(companyId: string): Promise<Companies | null> {
  const { data, error } = await apolloClient.query<GetCompanyQuery>({
    query: GetCompanyDocument,
    variables: { id: companyId },
    errorPolicy: "all",
    fetchPolicy: "network-only",
  });

  if (error) {
    console.error("Error fetching company:", error);
    throw new Error("Failed to fetch company data");
  }

  const node = data?.companiesCollection?.edges?.[0]?.node;
  return node ? (node as Companies) : null;
}

export async function fetchContactById(contactId: string): Promise<Contacts | null> {
  const { data, error } = await apolloClient.query<GetContactsQuery>({
    query: GetContactsDocument,
    variables: { id: contactId },
    errorPolicy: "all",
    fetchPolicy: "network-only",
  });

  if (error) {
    console.error("Error fetching contact:", error);
    throw new Error("Failed to fetch contact data");
  }

  const node = data?.contactsCollection?.edges?.[0]?.node;
  return node ? (node as Contacts) : null;
}
